module.exports = __webpack_public_path__ + "img/Building-Blocks-Logo-1.b561ab63.png";